<script setup>
import AppNavbar from '@/components/Shared/AppNavbar.vue';
import AppFooter from "@/components/Shared/AppFooter.vue";
import {useUxStore} from "@/stores/uxStore";

import { computed } from "vue";
import { useRoute } from "vue-router";
const uxStore = useUxStore();
const route = useRoute();
const restrictedShell = computed(() => ["AssignmentPending", "AccessSuspended", "AccessUnavailable", "AdministrativeMfa"].includes(route.name) || route.path.startsWith("/legal/"));


function navigateTo(module) {
  if (module === 'Invoices') {
    this.$router.push({ name: 'Invoices' });
  }
}

</script>

<template>
  <div id="app">
    <div
        v-if="uxStore.isLoading"
        role="status"
        class="position-fixed top-50 start-50 translate-middle"
        style="z-index: 9999"
    >
      <div class="d-flex align-items-center bg-white p-3 rounded-2 border border-2">
        <div class="spinner-border text-primary me-3" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
        <strong>Loading...</strong>
      </div>
    </div>

    <div v-if="uxStore.error"
         class="alert alert-danger alert-dismissible position-fixed top-50 start-50 translate-middle fade show"
         role="alert"
         style="z-index: 99999"
    >
      <strong>Fehler: </strong> {{ uxStore.error }}
      <button type="button" class="btn-close" data-dismiss="alert" aria-label="Close"
              @click="uxStore.error = null">
      </button>
    </div>
    <div class="app-shell">
      <AppNavbar v-if="!restrictedShell" @select="navigateTo" />
      <main class="app-main">
        <router-view />
      </main>
      <AppFooter />
    </div>
  </div>
</template>


<style>
#app {
  font-family: Arial, sans-serif;
  text-align: center;
  color: #333;
}

.app-shell {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.app-main {
  flex: 1 0 auto;
}

/* Lokale Überschreibung für Modals und Formulare */
.modal-content, 
.form-group {
  text-align: left; /* Labels und Inputs linksbündig */
}

.form-group label {
  display: block; /* Sicherstellen, dass Label über dem Input ist */
  margin-bottom: 0.5em;
}

.custom-btn {
  /* Kept for backward compatibility; actual color is provided via theme variables in src/themes/themes.css. */
}

.custom-btn:disabled {
  /* Kept for backward compatibility; actual color is provided via theme variables in src/themes/themes.css. */
}

/* Reset the margin for the last button */
.btn-group .btn:last-child {
  margin-right: 0 !important;
}

.ehw-green {
  /* Kept for backward compatibility; actual color is provided via theme variables in src/themes/themes.css. */
}
</style>
